import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { MAT_ANTENNA } from '../../../constants/MaterielConstants'

export const getAntennaType = (obj = {}) => ({
    materielCategory: MAT_ANTENNA,
    materielLabel: i18n.antenna,
    id: obj.materielType,
    code: obj.materielType,
    materielType: obj.materielType,
    name: obj.name,
    label: obj.name,
    provider: obj.provider,
    providerId: obj.provider,
    manufacturerId: obj.manufacturerId,
    comment: obj.comment,
    startDate: obj.startDate,
    endDate: obj.endDate,
    updateDate: obj.updateDate,
    updateLogin: obj.updateLogin,
    warrantyTime: obj.warrantyTime,
    duration: obj.duration,
    voltage: obj.voltage,
    nonReplaceable: obj.nonReplaceable,
    cableLength: obj.cableLength,
    locationSituation: obj.locationSituation,
    jobExecutionId: obj.jobExecutionId,
})

export const antennaTypeShape = PropTypes.shape({
    materielCategory: PropTypes.string,
    materielLabel: PropTypes.string,
    id: PropTypes.number,
    code: PropTypes.number,
    materielType: PropTypes.number,
    name: PropTypes.string,
    label: PropTypes.string,
    provider: PropTypes.number,
    providerId: PropTypes.number,
    manufacturerId: PropTypes.number,
    comment: PropTypes.string,
    startDate: PropTypes.number,
    endDate: PropTypes.number,
    updateDate: PropTypes.number,
    updateLogin: PropTypes.string,
    warrantyTime: PropTypes.number,
    duration: PropTypes.number,
    voltage: PropTypes.number,
    nonReplaceable: PropTypes.bool,
    cableLength: PropTypes.number,
    locationSituation: PropTypes.string,
    jobExecutionId: PropTypes.number,
})